<template>
  <base-modal
    ref="modal"
    :title="title"
    modal-class="js-modal-forgot-password-success o-modal--narrow"
    :hide-header="false"
    :force-interaction="true"
  >
    <p>{{ message }}</p>
    <template #footer>
      <a :href="loginUrl" class="c-button c-button--blue">{{ buttonLabel }}</a>
    </template>
  </base-modal>
</template>

<script>
import BaseModal from './BaseModal.vue';

export default {
  name: 'ForgotPasswordSuccessModal',
  components: {
    BaseModal,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    message: {
      type: String,
      required: true,
    },
    buttonLabel: {
      type: String,
      required: true,
    },
    loginUrl: {
      type: String,
      required: true,
    },
  },
  mounted() {
    this.$refs.modal.open();
  },
};
</script>
